(function () {
  var script = document.getElementById('cozyenjoy-popup-script');
  var popupImage = script && script.dataset.popupImage;
  var COPY = {
    title: '10% off your first CozyEnjoy',
    subtitle: 'Join the cozy list and we’ll send your welcome code.',
    placeholder: 'Email address',
    button: 'Send me 10% off',
    dismiss: 'No thanks',
    consent: 'By signing up, you agree to receive CozyEnjoy emails. Unsubscribe anytime.'
  };

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function updatePopup(root) {
    var modal = root.querySelector && root.querySelector('.react-responsive-modal-modal.pp-modal');
    if (!modal) return;

    var content = modal.querySelector('.ecomsend__Modal__Content');
    if (content && popupImage) {
      content.style.setProperty('--backgroundImage', 'url("' + popupImage + '")');
      content.style.backgroundImage = 'url("' + popupImage + '")';
    }

    var title = modal.querySelector('.ecomsend__Modal__TitleText');
    var subtitle = modal.querySelector('.ecomsend__Modal__TitleHelpText');
    var input = modal.querySelector('input[type="email"]');
    var button = modal.querySelector('.ecomsend__Button ._text_obcgu_68, .ecomsend__Button div');
    var dismiss = modal.querySelector('.ecomsend__Modal__CloseText');
    var consent = modal.querySelector('.ecomsend__Modal__DescriptionText p');

    setText(title, COPY.title);
    setText(subtitle, COPY.subtitle);
    if (input) {
      input.placeholder = COPY.placeholder;
      input.setAttribute('aria-label', COPY.placeholder);
    }
    setText(button, COPY.button);
    setText(dismiss, COPY.dismiss);
    setText(consent, COPY.consent);
    modal.setAttribute('aria-label', COPY.title);
  }

  function refresh() {
    updatePopup(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  new MutationObserver(refresh).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
